import classNames from 'classnames';
import ListItemContent from '@alltrails/denali/components/ListItemContent';
import Place from '@alltrails/denali/icons/Place';
import { CoordinatesResult } from '../../types/algoliaResultTypes';
import styles from './styles/styles.module.scss';

type CoordinatesResultContentProps = {
  result: CoordinatesResult;
};

const CoordinatesResultContent = ({ result }: CoordinatesResultContentProps) => {
  const icon = (
    <div className={styles.iconContainer}>
      <Place color="--color-text-secondary" />
    </div>
  );

  return (
    <ListItemContent
      className={classNames(styles.listItemContent, styles.noDescription)}
      leftContent={icon}
      label={
        <div className={styles.label}>
          {result.latitude}, {result.longitude}
        </div>
      }
      description={result.type}
      testId="coordinates-result"
    />
  );
};

export default CoordinatesResultContent;
